__turbopack_context__.v({
  "bulletItem": "ZPYAga_bulletItem",
  "bulletList": "ZPYAga_bulletList",
  "cardContainer": "ZPYAga_cardContainer",
  "checkIconWrapper": "ZPYAga_checkIconWrapper",
  "checklistContainer": "ZPYAga_checklistContainer",
  "checklistItem": "ZPYAga_checklistItem",
  "checklistLabel": "ZPYAga_checklistLabel",
  "chevronDown": "ZPYAga_chevronDown",
  "compactHeaderRow": "ZPYAga_compactHeaderRow",
  "defaultHeaderRow": "ZPYAga_defaultHeaderRow",
  "descRecoveryBlock": "ZPYAga_descRecoveryBlock",
  "detailsToggle": "ZPYAga_detailsToggle",
  "discountBadge": "ZPYAga_discountBadge",
  "headerRow": "ZPYAga_headerRow",
  "includesHeader": "ZPYAga_includesHeader",
  "includesInner": "ZPYAga_includesInner",
  "includesWrapper": "ZPYAga_includesWrapper",
  "inlinePriceRow": "ZPYAga_inlinePriceRow",
  "learnMoreChevron": "ZPYAga_learnMoreChevron",
  "metaDot": "ZPYAga_metaDot",
  "metaRow": "ZPYAga_metaRow",
  "nameDescBlock": "ZPYAga_nameDescBlock",
  "onRequestLabel": "ZPYAga_onRequestLabel",
  "originalPrice": "ZPYAga_originalPrice",
  "planDescription": "ZPYAga_planDescription",
  "planName": "ZPYAga_planName",
  "price": "ZPYAga_price",
  "priceButtonWrapper": "ZPYAga_priceButtonWrapper",
  "priceRow": "ZPYAga_priceRow",
  "quantityButton": "ZPYAga_quantityButton",
  "quantityControlsWrapper": "ZPYAga_quantityControlsWrapper",
  "quantityValue": "ZPYAga_quantityValue",
  "recoveryNote": "ZPYAga_recoveryNote",
  "serviceAddButton": "ZPYAga_serviceAddButton",
  "serviceCardContainer": "ZPYAga_serviceCardContainer",
  "serviceDescription": "ZPYAga_serviceDescription",
  "serviceName": "ZPYAga_serviceName",
  "serviceNameBlock": "ZPYAga_serviceNameBlock",
  "servicePrice": "ZPYAga_servicePrice",
  "serviceSeparator": "ZPYAga_serviceSeparator",
  "sessionInfo": "ZPYAga_sessionInfo",
  "thumbnail": "ZPYAga_thumbnail",
  "thumbnailPlaceholder": "ZPYAga_thumbnailPlaceholder",
  "validityBadge": "ZPYAga_validityBadge",
});
